import { Pipe, PipeTransform } from '@angular/core';

function initial(name: string): string {
	return name.charAt(0);
}

@Pipe({
	name: 'jepInitials',
	standalone: true,
})
export class JepInitialsPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return '';
		}

		const arrName = value.trim().toUpperCase().split(/\s+/);

		if (arrName.length > 1) {
			// Client names may include a hyphen-prefixed label (e.g. "John -DOE").
			// Skip that segment for initials: use the next word, or the text after
			// the hyphen when the label is the final segment.
			let secondName = arrName[1];
			if (
				arrName[1].charAt(0) === '–' ||
				arrName[1].charAt(0) === '-' ||
				arrName[1].charAt(0) === '—'
			) {
				secondName =
					arrName[2] && arrName[2].length > 0
						? arrName[2]
						: arrName[1].replace(/^[–—-]+/, '');
			}

			return initial(arrName[0]) + initial(secondName);
		}

		return initial(arrName[0]);
	}
}
